import { GraphType } from '@src/slide/infrastructure/module/dependent/shape-info/constant';
import { Locks } from '@src/slide/domain/ui-model/element-modeles/property/lock/lock.interface';
import { AddonMode } from '@src/slide/domain/ui-model/element-modeles/property/addon/addon.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';

// 插件默认宽高比与间距
const ADDON_RATIO = 0.56;
const ADDON_TOP = 200;

export default class AddonIframe {
    private uiDataService: IUiDataService;

    public constructor(
        public title: string,
        public embedUrl: string,
        public originUrl: string,
        public aid: string,
        public width?: number,
        public height?: number,
        public extraData?: string,
        public mode?: string,
        public docElement?: any,
    ) { }

    public setUiDataService(uiDataService: IUiDataService) {
        if (this.uiDataService) return;
        this.uiDataService = uiDataService;
    }

    public getAddonIframeProps() {
        const { width, height, top, left } = this.getIframePosition();
        const isIframeLockAspect = this.docElement?.lockAspectRatio;
        return {
            addon: {
                displayMode: this.mode || AddonMode.IFRAME,
                embedUrl: this.embedUrl,
                iframeId: this.aid,
                extraData: this.extraData,
                title: this.title,
                originUrl: this.originUrl,
                docElement: this.docElement,
            },
            style: {
                bgShape: GraphType.RECT,
                position: 'absolute',
                width,
                height,
                left,
                top,
            },
            subType: 1,
            [Locks.LOCKS]: { noChangeAspect: isIframeLockAspect ? 1 : 0 },
        };
    }

    // 默认宽高由ppt给出，与插件传入宽高无关
    private getIframePosition() {
        const { slideWidth, slideHeight } = this.uiDataService.presentation.props;
        const iframeHeight = this.height || slideHeight - (ADDON_TOP * 2);
        const iframeWidth = this.width || iframeHeight / ADDON_RATIO;
        const top = (slideHeight - iframeHeight) / 2;
        const left = (slideWidth - iframeWidth) / 2;

        return {
            width: iframeWidth,
            height: iframeHeight,
            top,
            left,
        };
    }
}
